<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jcj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Extrusion Machine</span>
          </u>
        </b>
        Extrusion Machine
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jcj: require("../../../assets/img/common/jcj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/jcj.vue